import React from 'react'

export const BlockCategory = ({ name }) => (
  <span className="category">{name}</span>
)